module.exports = __webpack_public_path__ + "img/header-weddingRingsCarbon.40352a6.jpg";